import { combineReducers } from 'redux'
import ScrumBoardReducer from './ScrumBoardReducer'
import NotificationReducer from './NotificationReducer'
import EcommerceReducer from './EcommerceReducer'
import NavigationReducer from './NavigationReducer'
import AlertsReducer from './AlertsReducer'
import UsersReducer from './UsersReducer'
import WaterMeterReducer from './WaterMeterReducer'
import MeasurementReducer from './MeasurementReducer'

const RootReducer = combineReducers({
	notifications: NotificationReducer,
	navigations: NavigationReducer,
	scrumboard: ScrumBoardReducer,
	ecommerce: EcommerceReducer,
	alerts: AlertsReducer,
	users: UsersReducer,
	waterMeter: WaterMeterReducer,
	measurement: MeasurementReducer
})

export default RootReducer
